import React, { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ActionsContext from "common/ActionsContext";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import { SubscriberFlowPoliciesTable } from "../Policies/component";
import RulesTreeReport from "../../Rules/RulesTree";
import RulesTable from "../../Rules/RulesTable";
import ConflictsButton from "../../Rules/ConflictsButton";
import {
  Wrapper,
  SubMenuWrapper,
  SelectWrapper,
} from "../../Rules/styles";
import {
  a11yProps,
  TabPanel,
  handleProfChange,
} from "../../Rules/utils";
import { PROFS, POLI, TYPE_PROFILE_SHORTCUTF_MAP } from "./constants";
import MarkdownHelpModal from "common/MarkdownHelpModal";
import treeHelp from "help/viewRulesFlowTree.md";
import rulesHelp from "help/viewRulesFlowRules.md";
import policiesHelp from "help/viewRulesFlowPolicies.md";


const _profileChoices = PROFS.map(({ type, titleEdit }) => ({
  value: type,
  label: titleEdit.replace(" Profile", ""),
}));

const titles = [
  "Subscriber flow rules and policies.",
  "List of subscriber flow rules.",
  "List of existing flow policies."
];

const SubscriberFlowsTabs = ({ rules, response, conflicts, tab, setTab }) => {
  const actions = useContext(ActionsContext);
  const currentTitle = titles[tab];
  const currentHelp = [treeHelp, rulesHelp, policiesHelp][tab];

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <Wrapper>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        aria-label="Subscriber Flows"
        className="rulesTabs"
      >
        <Tab
          label="RULES TREE-VIEW"
          id="rulesFlowTabTree"
          {...a11yProps(0)}
          disableRipple={true}
        />
        <Tab
          label="RULES TABLE-VIEW"
          id="rulesFlowTabTable"
          {...a11yProps(1)}
          disableRipple={true}
        />
        <Tab
          label="POLICIES"
          id="rulesFlowTabPolicies"
          {...a11yProps(2)}
          disableRipple={true}
        />
      </Tabs>
      <SubMenuWrapper>
        {tab !== 2 ? (
          <button
            type="button"
            className="btn btn-default waves-effect shadow-none hidden-to-operators"
            id="rulesFlowAddRuleBtn3"
            onClick={() => actions.send("open-rule-modal", { type: "Add" })}
          >
            <i className="material-icons">add_circle</i>
            <span>Add Rule...</span>
          </button>
        ) : null}
        <button
          type="button"
          className="btn btn-default waves-effect shadow-none"
          onClick={() => {
            globalNavigate("viewPolicyFlowEdit", {
              returnView: "viewRulesFlow",
              tab,
            });
          }}
        >
          <i className="material-icons">add_circle</i>
          <span>Add Policy...</span>
        </button>
        {tab !== 2 ? (
          <ConflictsButton
            conflicts={conflicts}
            view="flow"
            id="rulesFlowShowConflictsBtn"
          />
        ) : null}
        {tab !== 2 ? (
          <SelectWrapper>
            Manage
            <SelectInputWithIcon
              title="Manage Profiles"
              name="profilesSelect"
              selected={"init"}
              onChange={(e) => handleProfChange(e, "viewRulesFlow")}
              options={[{ value: "init", label: "" }, ..._profileChoices]}
              className="selectProfile"
            />
            Profiles...
          </SelectWrapper>
        ) : null}
      </SubMenuWrapper>
      <TabPanel value={tab} index={0}>
        <RulesTreeReport
          response={response}
          rules={rules}
          conflicts={conflicts}
          profs={PROFS}
          poli={POLI}
          typeProfileMap={TYPE_PROFILE_SHORTCUTF_MAP}
          view="flow"
        />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <RulesTable
          rules={rules}
          conflicts={conflicts}
          view="flow"
          profs={PROFS}
          poli={POLI}
          typeProfileMap={TYPE_PROFILE_SHORTCUTF_MAP}
        />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <SubscriberFlowPoliciesTable />
      </TabPanel>
      <MarkdownHelpModal title={currentTitle} source={currentHelp} />
    </Wrapper>
  );
};

export default SubscriberFlowsTabs;
